<script setup lang="ts">
  import { useOrdersStore } from '@/stores/orders.store';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import RestaurantPosNewOrdersItem from './RestaurantPosNewOrdersItem.vue';

  const restaurantStore = useRestaurantStore();
  const ordersStore = useOrdersStore();
</script>

<template>
  <div class="new-orders-container">
    <template v-if="!ordersStore.newOrders">Loading...</template>
    <template v-else-if="!ordersStore.newOrders.length">
      <p class="empty">
        <v-icon>mdi-information</v-icon>
        <span>No hay pedidos nuevos</span>
      </p>
    </template>
    <template v-else>
      <div class="orders">
        <RestaurantPosNewOrdersItem
          v-for="order in ordersStore.newOrders"
          :key="order.id"
          :order="order"
        />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
  .new-orders-container {
    .empty {
      @apply tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-gray-400 tw-p-4;
    }

    .orders {
      @apply tw-space-y-4;
    }
  }
</style>
